import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import merge from 'lodash/merge'
import { Link } from 'react-router-dom'

import { Form, Text, Select } from 'components/forms'
import ContentBlock from 'components/ContentBlock'
import Button from 'components/Button'
import { useMutation } from 'components/graphql'
import exportMirusMutation from '../../gql/exportMirus'

const TimeTracking = ({ formData, onUpdate, isLoading }) => {
	const [t] = useTranslation()
	const [exportMirus, { loading: exportLoading }] = useMutation(exportMirusMutation, {
		onCompleted: data => {
			const url = data?.exportMirus?.url
			if (url) {
				window.open(url, '_blank')
			}
		}
	})
	const [selectedExport, setSelectedExport] = useState(() => {
		if(formData.cashRegisterGlobal?.portosIntegrationKey) {
			return 'PORTOS'
		}
		if(formData.cashRegisterGlobal?.e2nIntegrationActive) {
			return 'E2N'
		}
		if(formData.appConfigAdditional?.brotZeitApiToken) {
			return 'BROTZEIT'
		}
		if(formData.appConfigAdditional?.pentacodeEnabled) {
			return 'PENTACODE'
		}
		if(formData.appConfigAdditional?.isMirusExportEnabled) {
			return 'MIRUS'
		}
		return 'NONE'
	})

	const handleSubmit = values => {
		const defaults = {
			cashRegisterGlobal: {
				portosIntegrationKey: null,
				e2nIntegrationActive: false,
				e2nReportingActive: false
			},
			appConfigAdditional: {
				brotZeitApiToken: null,
				brotzeitSubdomain: null,
				pentacodeEnabled: false,
				isMirusExportEnabled: false
			}
		}
		if(values?.appConfigAdditional?.brotZeitApiToken === true) {
			/* we dont get api token value on the client just that it is there ('true')
			   this here is to not overwrite 'true' back to the db */
			delete values.appConfigAdditional.brotZeitApiToken
			delete defaults.appConfigAdditional.brotZeitApiToken
		}
		const newValues = merge(defaults, values)
		onUpdate(newValues)
	}

	const handleSelect = ({ value }) => {
		setSelectedExport(value)
		if(value === 'NONE') {
			handleSubmit({})
		}
		if(value === 'E2N') {
			handleSubmit({
				cashRegisterGlobal: {
					e2nIntegrationActive: true,
					e2nReportingActive: true
				}
			})
		}
		if(value === 'PENTACODE') {
			handleSubmit({
				appConfigAdditional: {
					pentacodeEnabled: true
				}
			})
		}
		if(value === 'MIRUS') {
			handleSubmit({
				appConfigAdditional: {
					isMirusExportEnabled: true
				}
			})
		}
	}

	return(
		<ContentBlock isLoading={isLoading} label={t(`options_section.strings.time_tracking`)}>
			<Select
				noForm
				value={selectedExport}
				onChange={handleSelect}
				options={[{
					value: 'NONE',
					label: t('common.strings.none')
				}, {
					value: 'BROTZEIT',
					label: 'Brotzeit'
				}, {
					value: 'E2N',
					label: 'E2N'
				}, {
					value: 'PORTOS',
					label: 'Portos'
				}, {
					value: 'PENTACODE',
					label: 'Pentacode'
				}, {
					value: 'MIRUS',
					label: 'Mirus'
				}]}
			/>
			<Form smartSubmit initialValues={formData} onSubmit={handleSubmit}>
				{selectedExport === 'BROTZEIT' && <>
					<Text
						type='password'
						disablePasswordAutoComplete
						label={t('options_section.fields.brotzeit_api_token')}
						field='appConfigAdditional.brotZeitApiToken'
					/>
					<Text
						label={t('options_section.fields.brotzeit_endpoint')}
						field='appConfigAdditional.brotzeitSubdomain'
					/>
				</>}
				{selectedExport === 'PORTOS' &&
					<Text
						type='password'
						disablePasswordAutoComplete
						field='cashRegisterGlobal.portosIntegrationKey'
						label={t('options_section.fields.portos_api_key')}
					/>
				}
				{selectedExport === 'E2N' &&
					<p className='form-group-label'>Der API-Key wird pro Filiale gesetzt. Navigiere daher zu <Link to='/optionen/kasse/filiale/'>Optionen - Kasse - Filiale</Link></p>
				}
				{selectedExport === 'PENTACODE' && <>
					<p className='form-group-label'>
						{t('options_section.strings.pair_with_device')} <Link to='/optionen/kasse/einstellung/'>{t('options_section.caption')} - {t('options_section.strings.cash_registers_config')} - {t('options_section.strings.cash_register')} - {t('options_section.strings.time_tracking')}</Link><br/>
						{t('options_section.strings.assign_user_extern_number')} <Link to='/benutzer/rechte/'>{t('user_section.caption')} - {t('user_section.sub_sections.rights')}</Link>
					</p>
				</>}
				{selectedExport === 'MIRUS' && <>
					<Button
						text={t('options_section.strings.export_mirus_data')}
						isLoading={exportLoading}
						onClick={exportMirus}
					/>
				</>}
			</Form>
		</ContentBlock>
	)
}

export default TimeTracking
